import { FC, memo, SVGProps, useEffect, useRef } from 'react';

interface SvgIconProps extends SVGProps<SVGSVGElement> {
  svgString: string;
}

const defaultProps = {
  width: '24',
  height: '24',
  viewBox: '0 0 16 16',
};

const SvgIcon: FC<SvgIconProps> = ({ svgString, ...props }) => {
  const ref = useRef<SVGSVGElement | null>(null);

  useEffect(() => {
    if (ref.current) {
      const parser = new DOMParser();

      const document = parser.parseFromString(svgString, 'image/svg+xml');
      const innerSvg = document.documentElement;

      if (innerSvg.tagName.toLowerCase() === 'svg') {
        ref.current.innerHTML = innerSvg.innerHTML;
      } else {
        ref.current.innerHTML = svgString;
      }
    }
  }, [svgString]);

  const svgProps = { ...defaultProps, ...props };

  return <svg ref={ref} {...svgProps} />;
};

export default memo(SvgIcon);
